import { Fragment } from "react";
import Layout from "./components/layout/Layout";
import { viewFor } from "./routes";

/** Root component, shared by client hydration and the prerender script. */
export default function App({ path = "/" }) {
  return (
    <Layout path={path}>
      <Fragment key={path}>{viewFor(path)}</Fragment>
    </Layout>
  );
}
